const ExpenseApprovals: React.FC = () => {
  return <div>Expense Approvals</div>
}

export default ExpenseApprovals
